"use strict";
// alert("Hello IT");
// // var answer = prompt("do you?");
// // if (answer) {
// //   console.log("yes")
// // }
